export default [
  {
    path: "/custom-module/:page",
    name: "custom-module",
    component: () =>
      import("@/views/pages/customs-module/CustomModule.vue"),
    meta: {},
    breadcrumb: [],
  },
];
